/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line import/no-extraneous-dependencies
import useCurrentLoggedInUser from 'hooks/apollo/queries/useCurrentLoggedInUser';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { AuthAction } from 'redux/actions';
import AuthSelectors from 'redux/auth/auth.selectors';
import { RoleEnum, UserStatusEnum } from 'types/user';

import ROUTES from './routeConstants';

type CustomRouteProps<T> = T & RouteProps;

type RoleProtectedProps = {
  allow: RoleEnum | RoleEnum[];
  blocked?: boolean;
};

type ProtectedProps = {
  failureRedirect?: string;
};

export const PrivateRoute: React.FC<CustomRouteProps<ProtectedProps>> = ({ failureRedirect, location, ...rest }) => {
  const { accessToken, expires } = useSelector(AuthSelectors.selectAuth);

  const userStatus = useCurrentLoggedInUser().status;
  const restrictedUserStatuses = useMemo(() => [UserStatusEnum.REGISTERED], []);

  const dispatch = useDispatch();
  const publicRoutes: string[] = useMemo(() => [ROUTES.SIGN_IN, ROUTES.SIGN_UP, ROUTES.RESET_PASSWORD], []);

  useEffect(() => {
    if (location?.pathname && !publicRoutes.includes(location?.pathname)) {
      if (!accessToken || !expires) {
        if (location?.pathname === ROUTES.DASHBOARD) return;
        dispatch(
          AuthAction.userSignOut({
            redirectUrl: failureRedirect,
          }),
        );
      }
    }
  }, [accessToken, expires]);

  if (userStatus && restrictedUserStatuses.includes(userStatus) && location?.pathname !== ROUTES.USER_WIZARD) {
    console.log('test', userStatus);

    return <Redirect to={ROUTES.USER_WIZARD} />;
  }

  if (!accessToken) {
    return (
      <Redirect
        to={{
          pathname: failureRedirect || ROUTES.SIGN_IN,
          search: location?.pathname ? `?redirect=${location.pathname}` : '',
          state: { from: location },
        }}
      />
    );
  }

  return <Route {...rest} />;
};

export const PublicRoute: React.FC<RouteProps> = ({ location, ...rest }) => {
  const { accessToken, expires } = useSelector(AuthSelectors.selectAuth);
  if (accessToken && (expires || 0) > Date.now()) {
    return (
      <Redirect
        to={{
          pathname: ROUTES.DASHBOARD,
          state: { from: location },
        }}
      />
    );
  }

  return <Route {...rest} />;
};

export const RoleProtectedRoute = (route: CustomRouteProps<RoleProtectedProps>) => {
  const { allow, blocked, ...restProps } = route;
  const { role } = useCurrentLoggedInUser();

  if (![allow].flat().includes(role as RoleEnum) || blocked) return <Redirect to='/' />;

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <PrivateRoute {...restProps} />;
};
